import { isPlatform } from '@baloise/ds-core';
import { Component, h, Host, Listen, Prop, State } from '@stencil/core';

@Component({
  tag: 'bam-notifications-wrapper',
  styleUrl: 'bam-notifications-wrapper.scss',
})
export class BamNotificationsWrapper {
  @State() hidden: boolean = true;
  @State() isMobile: boolean = isPlatform('mobile');

  @Prop() chatbotActive: boolean = false;
  @Prop() open: boolean = false;
  
  private footer: HTMLElement;
  private header: HTMLHeadElement;

  @Listen('resize', { target: 'window' })
  handleResize() {
    this.isMobile = isPlatform('mobile');
  }

  @Listen('scroll', { target: 'window' })
  handleScroll() {
    this.hidden =
      (!isPlatform('desktop') && this.header?.clientHeight > 200) ||
      window.scrollY <= 50 ||
      (isPlatform('mobile') && this.footer?.offsetTop - window.scrollY < this.footer?.offsetHeight);
  }

  componentWillLoad() {
    this.footer = document.querySelector('footer');
    this.header = document.querySelector('header');
  }

  render() {
    return (
      <Host class={this.chatbotActive ? 'has-chatbot' : ''}>
        <slot name="notifications"></slot>
        <slot name="chatbot"></slot>
        <div
          class={{
            'cta-wrapper flex justify-content-end': true,
            'hidden': this.hidden,
            'mt-normal': !this.isMobile,
            'flex-direction-column': this.isMobile && !this.open,
          }}
        >
          <slot name="helpbox"></slot>
          {!Boolean(this.chatbotActive) && (
            <bal-button
              data-tracking-style="cta"
              data-tracking-context="to-top-btn"
              data-tracking-topic="go_up_clicked"
              data-tracking-area="content"
              data-tracking-id="nav-go-up#to-top-btn"
              onClick={event => {
                window.track(event);
                window.scroll({ top: 0, behavior: 'smooth' });
              }}
              class={{
                'to-top-btn ml-x-small': true,
                'mt-x-small': this.isMobile,
              }}
              color="primary"
              square={true}
              icon="nav-go-up"
            />
          )}
        </div>
      </Host>
    );
  }
}
